import { Outlet, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";

export default function DashboardLayout() {
  const location = useLocation();
  const hideSidebarRoutes = ["/chatbots", "/chatbot/create", "/billing", "/demo", "/profile"];
  const shouldHideSidebar = hideSidebarRoutes.includes(location.pathname);

  return (
    <div className="h-screen bg-gray-50">
      {/* Fixed Header */}
      <Header />

      <div className="flex pt-16">
        {/* Sidebar (conditionally rendered) */}
        {!shouldHideSidebar && <Sidebar />}

        {/* Scrollable Content */}
        <main
          className={`w-full h-[calc(100vh-4rem)] overflow-y-auto p-6 ${
            !shouldHideSidebar ? "ml-64" : ""
          }`}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
